import {
  Dropdown,
  dropdownTypes,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { exportUsageReport } from "slices/systemAdmin/actions/systemAdmin";
import { exportActivityReport } from "slices/systemAdmin/actions/users";

export const exportModalTypes = {
  usage: "usage",
  activity: "activity",
};

const options = [
  { content: <span>All Time</span>, value: "all_time" },
  { content: <span>12 Months</span>, value: "12m" },
  { content: <span>6 Months</span>, value: "6m" },
  { content: <span>3 Months</span>, value: "3m" },
  { content: <span>1 Month</span>, value: "1m" },
];

const ExportReportModal = ({ exportType }) => {
  const dispatch = useDispatch();

  const [dropdownSelected, setDropdownSelected] = useState(options[0]);

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.EXPORT_REPORT));
  };

  const handleExport = () => {
    if (exportType === exportModalTypes.usage) {
      dispatch(exportUsageReport(dropdownSelected.value));
    } else {
      dispatch(exportActivityReport(dropdownSelected.value));
    }
  };

  return (
    <Modal
      data-testid="exportReportModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
    >
      <Modal.Header>
        <b className="export__usage__modal__header">
          {exportType === exportModalTypes.usage
            ? "Export Usage Report"
            : "Export Activity Report"}
        </b>
      </Modal.Header>
      <Modal.Body
        className="export__usage__modal modal__body"
        data-testid="export-modal-body"
      >
        <span>Export data for the last:</span>
        <Dropdown
          type={dropdownTypes.simple}
          propsObject={{
            options,
            dropdownSelected,
            setDropdownSelected,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="cancelButton"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-test="saveButton"
          variant={NewButtonVariant.l1}
          onClick={handleExport}
          disabled={false}
        >
          Export
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportReportModal;

ExportReportModal.propTypes = {
  exportType: PropTypes.string.isRequired,
};
